module.exports = __webpack_public_path__ + "img/indicate_icon_2.e8d67b77.png";